import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    SelectSearchDataComponent
} from '../../../../../../../components/common/select-search-data/select-search-data.component';
import {UntypedFormGroup} from '@angular/forms';
import {NewItemModalOptions} from '../../../../../../core/component/select/abstract-select.component';
import {FormDefinitionFieldModel} from '../../entity/formDefinitionField.model';
import {FormDefinitionFieldFindOneByIdService} from "../../../impl/service/formDefinitionFieldFindOneById.service";
import {FormDefinitionFieldSummaryModel} from "../../entity/formDefinitionFieldSummary.model";
import {BaseView} from "../../../../../../core/view/base.view";

@Component({
    selector: 'app-form-definition-field-search-by-label',
    templateUrl: './form-definition-field-search-by-label.component.html',
    providers: [
        FormDefinitionFieldFindOneByIdService
    ]
})
export class FormDefinitionFieldSearchByLabelComponent<K, V> extends BaseView{

    @ViewChild('selectSearch') selectSearchComponent: SelectSearchDataComponent<FormDefinitionFieldModel>;

    @Input() contextValue: string;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() value: FormDefinitionFieldModel;
    // @Input() newItemModalOptions: NewItemModalOptions<number>;
    @Input() errorsMessages: {[key: string]: string};
    @Input() onlyActive = true;
    @Input() attributeValue: 'id' | 'name';
    @Input() computed: boolean;

    @Output() changeEvent = new EventEmitter<FormDefinitionFieldModel>();

    constructor(public findOneByIdService: FormDefinitionFieldFindOneByIdService) {
        super();
    }

    change(entity: FormDefinitionFieldSummaryModel) {
        if (this.changeEvent) {
            this.findOneByIdService.loadEntity(entity)
                .then((r) => this.changeEvent.emit(r))
                .catch(e => this.toastControl.presentError(e));
        }
    }
}
